import React from 'react';
import { Form } from 'react-bootstrap';
import { FormNumber } from '~/components/FormControl';

function RewardPenaltyDetail() {
    return (
        <>
            <Form.Row className="justify-content-between">
                <FormNumber
                    name="rewardPenaltyDetail.lampRewardValue"
                    sm={3}
                    tooltip="Award lamp to player."
                />
                <FormNumber
                    name="rewardPenaltyDetail.pointRewardValue"
                    sm={3}
                    tooltip="Award points to player."
                />
                <FormNumber
                    name="rewardPenaltyDetail.upgradeRewardValue"
                    sm={3}
                    tooltip="Award stack of upgrades to player."
                />
                <FormNumber
                    name="rewardPenaltyDetail.manaRewardValue"
                    sm={3}
                    tooltip="Award mana to player."
                />
            </Form.Row>
            <Form.Row className="justify-content-between">
                <FormNumber
                    name="rewardPenaltyDetail.lampRemovedValue"
                    sm={3}
                    tooltip="Remove lamp when an effect for card is used."
                />
                <FormNumber
                    name="rewardPenaltyDetail.point1RemovedValue"
                    sm={3}
                    tooltip="Remove points when an effect for card is used."
                />
                <FormNumber
                    name="rewardPenaltyDetail.point2RemovedValue"
                    sm={3}
                    tooltip="Remove points when an effect for the 2nd effect related to removing points."
                />
                <FormNumber
                    name="rewardPenaltyDetail.upgradeRemovedValue"
                    sm={3}
                    tooltip="Remove Upgrade stacks when effect for card is used."
                />
            </Form.Row>
            <Form.Row className="justify-content-between">
                <FormNumber
                    name="rewardPenaltyDetail.manaRemovedValue"
                    sm={3}
                    tooltip="Remove mana when an effect for card is used."
                />
            </Form.Row>
        </>
    );
}

export default RewardPenaltyDetail;
